import React from "react";
import { useState, useEffect } from "react";
import "./showcase_presentations.css";
import "../../../index.css";
import {
  showcasePresentersData,
  showcasePresentersDataCWPC,
  allShowcasesData,
} from "./showcaseData_copy";
import Button from "../../../components/button/button";
import Video from "../../../components/video/video";
import PopUpModal from "../../../popUpForms/formModals/popUpFormModal";
import PopUpFormNotify from "../../../popUpForms/popUpFormNotify";
import { upcomingShowcase } from "../../../utils/showcaseDates";

const ShowcasePresentations = () => {
  const [currentShowcaseGeneral, setCurrentShowcaseGeneral] = useState();
  const [currentShowcaseCWPC, setCurrentShowcaseCWPC] = useState();
  const [currentShowcase, setCurrentShowcase] = useState([]);
  const [showRegistrationClosedModal, setShowRegistrationClosedModal] =
    useState(false);

  useEffect(() => {
    const storedDate = sessionStorage.getItem("showcaseDateSelected");
    const date = storedDate || null;
    if (date) {
      handleChooseShowcaseByDate(date);
    } else {
      handleChooseShowcaseByDate(
        allShowcasesData[allShowcasesData.length - 1]?.date
      );
    }
  }, []);

  const handleChooseShowcaseByDate = (date) => {
    sessionStorage.setItem("showcaseDateSelected", date);

    const tempCurrentShowcaseGeneral = allShowcasesData.find(
      (showcase) => showcase.date === date
    );
    setCurrentShowcaseGeneral(tempCurrentShowcaseGeneral);

    const tempCurrentShowcaseCWPC = showcasePresentersDataCWPC.find(
      (showcase) => showcase.showcaseDate === date
    );
    setCurrentShowcaseCWPC(tempCurrentShowcaseCWPC);

    const tempCurrentShowcase = showcasePresentersData.filter(
      (showcase) => showcase.showcaseDate === date && showcase.display === true
    );

    setCurrentShowcase(tempCurrentShowcase);
  };

  return (
    <>
      <>
        <PopUpModal
          activeForm={"notify"}
          formActiveState={showRegistrationClosedModal}
          setFormActiveState={setShowRegistrationClosedModal}
        >
          <PopUpFormNotify />
        </PopUpModal>
      </>
      <div className="showcase-presentations">
        <div className="hero">
          <video autoPlay muted loop>
            <source
              src="/assets/showcase-presentations-assets/showcase-feb-5-clip.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
          <div className="hero-overlay">
            <div className="hero-header large-screen-limit">
              <h1>WILDFIRE INNOVATION SHOWCASE</h1>
              <h3>
                Hosted by Catastrophic Wildfire Prevention Consortium and
                Venture Starters
              </h3>
              <h3>Free to attend. Free to present.</h3>
              <div className="button-group">
                <Button
                  text="Apply to Present"
                  color="var(--light-green)"
                  link="https://docs.google.com/forms/d/e/1FAIpQLSeSs3XsYEIguFjQ4i9jBQ9nxmYNmNDnhbv_q4qeOtQzWani4g/viewform"
                ></Button>

                {upcomingShowcase ? (
                  <Button
                    text="Register"
                    color="var(--orange)"
                    link="https://venturestarters.com/"
                  ></Button>
                ) : (
                  <Button
                    text="Notify Me"
                    color="var(--orange)"
                    onClick={() => setShowRegistrationClosedModal(true)}
                  ></Button>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="overall-information ">
          <div className="content large-screen-limit">
            <div className="para">
              <h2>Wildfire Innovation Showcase</h2>
              <p>
                The Wildfire Innovation Showcase, hosted by the Catastrophic
                Wildfire Prevention Consortium (CWPC) and Venture Starters, is a
                virtual event that connects visionary entrepreneurs with impact
                investors and mission-aligned capital. Our showcase highlights a
                diverse range of innovations across various technologies and
                applications, with the goal of addressing critical gaps in
                wildfire prevention, community resilience, and regeneration.
              </p>
              <p>
                Our showcase covers a broad spectrum of innovations, from
                traditional, fire-resistant vegetation and early detection
                technologies to community-powered prevention and engagement
                tools. We seek to unlock the potential cutting-edge solutions,
                through a comprehensive approach, and create a robust ecosystem
                of partnerships to tackle the growing challenges posed by
                wildfires.
              </p>
            </div>
            <div className="para">
              <h2>
                Catastrophic Wildfire Prevention Consortium{" "}
                <span className="logo-wrapper">
                  (CWPC){" "}
                  <img
                    src="/assets/showcase-presentations-assets/cwpc-logo.svg"
                    alt="CWPC Logo"
                  />
                </span>
              </h2>
              <p>
                The Catastrophic Wildfire Prevention Consortium (CWPC) is an
                international coalition of wildfire experts, startups,
                institutions, and volunteers dedicated to reducing the risk of
                catastrophic wildfires. By synergizing a diverse set of
                innovations—blending new and traditional methods—CWPC works to
                prevent, mitigate, and adapt to wildfire risks, making
                communities safer, more resilient, and regenerative.
              </p>
            </div>
            <div className="para">
              <h2>
                Venture Starters{" "}
                <img
                  src="/assets/showcase-presentations-assets/venture-starters-logo.jpg"
                  alt="Venture Starters Logo"
                />
              </h2>
              <p>
                Venture Starters is a leading, online networking community for
                startups and early-stage companies that offers investors,
                founders, mentors, and service providers a platform to pitch
                their innovations and gain positive outcomes for their growing
                institutions.
              </p>

              <div className="register-btn-group">
                {upcomingShowcase ? (
                  <Button
                    text="Register"
                    color="var(--orange)"
                    link="https://venturestarters.com/"
                  ></Button>
                ) : (
                  <Button
                    text="Notify Me"
                    color="var(--orange)"
                    onClick={() => setShowRegistrationClosedModal(true)}
                  ></Button>
                )}
              </div>
            </div>
          </div>
        </div>

        <h1 className="previous-showcases-header">
          Previous Innovation Showcases
        </h1>
        <div className="select-showcase-tabs ">
          <div className="tabs-wrapper large-screen-limit">
            {allShowcasesData &&
              allShowcasesData.map((tab, index) => (
                <button
                  key={index}
                  onClick={() => handleChooseShowcaseByDate(tab.date)}
                  style={{
                    backgroundColor:
                      currentShowcaseGeneral?.date === tab.date &&
                      "var(--green)",
                  }}
                >
                  {tab.dateShow}
                </button>
              ))}
          </div>
        </div>
        <div className="individual-showcase">
          <div className="individual-showcase-intro large-screen-limit">
            <h2>
              <div className="showcase-name">
                {currentShowcaseGeneral?.showcaseHeaderName}
              </div>
            </h2>
            <h3>
              <div className="showcase-date">
                {currentShowcaseGeneral?.showcaseHeaderDate}
              </div>
            </h3>
            <div className="showcase-full-video">
              <Video
                key={currentShowcaseGeneral?.date}
                youtube={currentShowcaseGeneral?.fullVideo}
                name={currentShowcaseGeneral?.showcaseHeaderName}
                poster={currentShowcaseGeneral?.videoPreview}
              ></Video>
            </div>
          </div>
          <div className="innovator-profiles large-screen-limit">
            <h2 className="profiles-header">
              Catastrophic Wildfire Prevention Consortium (CWPC)
            </h2>
            <div id="innovator-profiles">
              {currentShowcaseCWPC && (
                <div className="profile-card card-two-presenters">
                  <div className="profile-card-personal ">
                    <div className="person">
                      <div className="headshot">
                        <img
                          src={currentShowcaseCWPC?.presenterPhoto1}
                          alt={currentShowcaseCWPC?.presenterName1}
                        />
                      </div>

                      <div className="personal-data-group">
                        <div className="logo">
                          <div>
                            <img
                              src={currentShowcaseCWPC?.orgLogo1}
                              alt={currentShowcaseCWPC?.orgName1}
                            />
                          </div>{" "}
                          <a
                            style={{
                              display:
                                currentShowcaseCWPC?.linkedin1 !== ""
                                  ? "block"
                                  : "none",
                              color:
                                currentShowcaseCWPC?.linkedin1 !== "" &&
                                "var(--black)",
                            }}
                            href={currentShowcaseCWPC?.linkedin1}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa-brands fa-linkedin"></i>
                          </a>
                        </div>
                        <div className="name">
                          <span className="first-name">
                            {currentShowcaseCWPC?.presenterName1?.split(" ")[0]}
                          </span>
                          <span className="last-name">
                            {currentShowcaseCWPC?.presenterName1
                              ?.split(" ")
                              .slice(1)
                              .join(" ")}{" "}
                            <a
                              style={{
                                display:
                                  currentShowcaseCWPC?.linkedinPersonal1 !== ""
                                    ? "block"
                                    : "none",
                              }}
                              href={currentShowcaseCWPC?.linkedinPersonal1}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <i className="fa-brands fa-linkedin"></i>
                            </a>
                          </span>
                        </div>

                        <div className="role">
                          {currentShowcaseCWPC?.presenterRole1} |
                          {currentShowcaseCWPC?.orgName1}{" "}
                        </div>
                        <div className="location">
                          {currentShowcaseCWPC?.location1}{" "}
                        </div>
                      </div>
                    </div>

                    <div className="person">
                      <div className="headshot">
                        <img
                          src={currentShowcaseCWPC?.presenterPhoto2}
                          alt={currentShowcaseCWPC?.presenterName2}
                        />
                      </div>

                      <div className="personal-data-group">
                        <div className="logo">
                          <div>
                            <img
                              src={currentShowcaseCWPC?.orgLogo2}
                              alt={currentShowcaseCWPC?.orgName2}
                            />
                          </div>{" "}
                          <a
                            style={{
                              display:
                                currentShowcaseCWPC?.linkedin2 !== ""
                                  ? "block"
                                  : "none",
                              color:
                                currentShowcaseCWPC?.linkedin1 !== "" &&
                                "var(--black)",
                            }}
                            href={currentShowcaseCWPC?.linkedin2}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa-brands fa-linkedin"></i>
                          </a>
                        </div>

                        <div className="name">
                          <span className="first-name">
                            {currentShowcaseCWPC?.presenterName2?.split(" ")[0]}
                          </span>
                          <span className="last-name">
                            {currentShowcaseCWPC?.presenterName2
                              ?.split(" ")
                              .slice(1)
                              .join(" ")}{" "}
                            <a
                              style={{
                                display:
                                  currentShowcaseCWPC?.linkedinPersonal2 !== ""
                                    ? "block"
                                    : "none",
                              }}
                              href={currentShowcaseCWPC?.linkedinPersonal2}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <i className="fa-brands fa-linkedin"></i>
                            </a>
                          </span>
                        </div>

                        <div className="role">
                          {currentShowcaseCWPC?.presenterRole2} |
                          {currentShowcaseCWPC?.orgName2}{" "}
                        </div>
                        <div className="location">
                          {currentShowcaseCWPC?.location2}{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="profile-card-presentation">
                    <div className="presentation-clip">
                      {currentShowcaseCWPC?.youtube &&
                      currentShowcaseCWPC?.youtube !== "" ? (
                        <Video
                          key={`${currentShowcaseCWPC?.youtube.start}-${currentShowcaseCWPC?.youtube.end}`}
                          name={currentShowcaseCWPC?.presenterName1}
                          poster={currentShowcaseCWPC?.videoPreview}
                          youtube={currentShowcaseCWPC?.youtube}
                        />
                      ) : (
                        <video
                          key={`${currentShowcaseCWPC?.video}`}
                          controls
                          poster={currentShowcaseCWPC?.videoPreview}
                        >
                          <source
                            src={currentShowcaseCWPC?.video}
                            type="video/mp4"
                          />
                          Your browser does not support the video tag.
                        </video>
                      )}
                    </div>
                    <div className="organization-description">
                      {currentShowcaseCWPC?.orgDescription}
                    </div>
                    <a
                      href={currentShowcaseCWPC?.slides}
                      style={{
                        cursor:
                          currentShowcaseCWPC?.slides !== ""
                            ? "pointer"
                            : "default",
                        pointerEvents:
                          currentShowcaseCWPC?.slides !== "" ? "auto" : "none",
                      }}
                      className="show-slides"
                      download="Claudia Brenner (CWPC) Robert Fishkin (Venture Starters) slides.pptx"
                    >
                      <Button
                        text="View Presentation Slides"
                        color="var(--orange)"
                      ></Button>
                    </a>
                  </div>
                </div>
              )}
              <h2 className="profiles-header">Innovators</h2>
              {currentShowcase &&
                currentShowcase.map((innovator, index) => (
                  <div key={index} className="profile-card">
                    <div className="profile-card-personal">
                      <div className="headshot">
                        <img
                          src={innovator.presenterPhoto}
                          alt={innovator.presenterName}
                        />
                      </div>
                      <div className="logo">
                        <div>
                          <img
                            src={innovator.orgLogo}
                            alt={innovator.orgName}
                          />
                        </div>{" "}
                        <a
                          style={{
                            display:
                              innovator.linkedin !== "" ? "block" : "none",
                            color: innovator.linkedin !== "" && "var(--black)",
                          }}
                          href={innovator.linkedin}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fa-brands fa-linkedin"></i>
                        </a>{" "}
                      </div>
                      <div className="personal-data-group">
                        <div className="name">
                          <span className="first-name">
                            {innovator.presenterName.split(" ")[0]}
                          </span>
                          <span className="last-name">
                            {innovator.presenterName
                              ?.split(" ")
                              .slice(1)
                              .join(" ")}{" "}
                            <a
                              style={{
                                display:
                                  innovator.linkedinPersonal !== ""
                                    ? "block"
                                    : "none",
                              }}
                              href={innovator.linkedinPersonal}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <i className="fa-brands fa-linkedin"></i>
                            </a>
                          </span>
                        </div>
                        <div className="role">
                          {innovator.presenterRole} | {innovator.orgName}{" "}
                        </div>
                        <div className="location">{innovator.location} </div>
                      </div>
                    </div>
                    <div className="profile-card-presentation">
                      <Video
                        key={`${innovator.youtube.start}-${innovator.youtube.end}`}
                        name={innovator.presenterName}
                        poster={innovator.videoPreview}
                        youtube={innovator.youtube}
                      />

                      <div className="organization-description">
                        {innovator.orgDescription}
                      </div>
                      <a
                        href={innovator.slides}
                        style={{
                          display:
                            innovator.slides && innovator.slides.trim() !== ""
                              ? ""
                              : "none",
                        }}
                        className="show-slides"
                        download={`${innovator.presenterName}_${innovator.orgName}_slides.pdf`}
                      >
                        <Button
                          text="View Presentation Slides"
                          color="var(--orange)"
                        ></Button>
                      </a>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShowcasePresentations;
